import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";
import {ProtectDistributorRoute} from "../components/ProtectRoute";

// Distributor Layout
const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout")));
// const DistributorLayout = Loadable(lazy(() => import("../layouts/DistributorLayout")));
// Privacy Policy
const PrivacyPolicy = Loadable(lazy(() => import("../views/importantDocs/privacyPolicy")));
// Terms And Condition
const TermsAndCondition = Loadable(lazy(() => import("../views/importantDocs/termsAndCondition")));
// Distributor Dashboard
const DistributorDashboard = Loadable(lazy(() => import("../views/distributors/dashboard")));
// Change Password
const ChangesPassword = Loadable(lazy(() => import("../views/Admin/UserManagement/changesPassword")));
// Change TPin
const ChangeTPinWithOld = Loadable(lazy(() => import("../views/Admin/UserManagement/changeTPinWithOld")));
// OnBoarding KYC
const AddDocumentKyc = Loadable(lazy(() => import("../views/profiles/addDocumentKyc")));
// Profile
const UserProfileHome = Loadable(lazy(() => import("../views/profiles/userProfile/userProfileHome")));
// Self Bank
const SelfBank = Loadable(lazy(() => import("../views/bank/selfBank")));
// User Balance Request
const BalanceRequestList = Loadable(lazy(() => import("../views/balanceRequest/balanceRequestList")));
const NewBalanceRequest = Loadable(lazy(() => import("../views/balanceRequest/newBalanceRequest")));
const ViewPendingRequestAdmin = Loadable(lazy(() => import("../views/Admin/BalanceRequest/viewPendingRequestAdmin")));
// User Management
const UserManagementList = Loadable(lazy(() => import("../views/Admin/UserManagement/userManagement")));
const AddNewUserAdmin = Loadable(lazy(() => import("../views/Admin/UserManagement/addNewUser")));
const UpdateUserProfileAdmin = Loadable(lazy(() => import("../views/Admin/UserManagement/userProfiles/userProfileMenu")));
const PendingKycVerificationList = Loadable(lazy(() => import("../views/Admin/UserManagement/pendingKycVerification")));
// User Manage Credit/Debit
const ManageCreditDebit = Loadable(lazy(() => import("../views/distributors/manageCreditDebit")));
// User Credit Details
const CreditDetails = Loadable(lazy(() => import("../views/distributors/creditDetails")));
// User Wallet to Wallet Transfer
const WalletToWalletTransferReports = Loadable(lazy(() => import("../views/distributors/walletToWalletTransferReports")));
const WalletToWalletTransfer = Loadable(lazy(() => import("../views/distributors/walletToWalletTransfer")));
// User Services
const BillPayments = Loadable(lazy(() => import("../views/services/billPayments/billPayments")));
const OfflineBillPayments = Loadable(lazy(() => import("../views/services/billPayments/offlineBillPayment")));
const RechargeBill = Loadable(lazy(() => import("../views/services/recharges/recharge")));
const AllPaymentsHome = Loadable(lazy(() => import("../views/services/payments/allPaymentsHome")));
const AEPSHome = Loadable(lazy(() => import("../views/services/aeps/aepsHome")));
const ECollection = Loadable(lazy(() => import("../views/services/eCollection")));
// const UPPaymentsHome = Loadable(lazy(() => import("../views/services/upiPayments/upiPaymentsHome")));
// const PayoutHome = Loadable(lazy(() => import("../views/services/payout/payoutHome")));
// User Reports
const LedgerReport = Loadable(lazy(() => import("../views/distributors/reports/ledgerReport")));
const MainWalletLedgerReport = Loadable(lazy(() => import("../views/distributors/reports/mainWalletLedgerReport")));
const PGLedgerReportRetailer = Loadable(lazy(() => import("../views/distributors/reports/pgLedgerReport")));
const CashoutReport = Loadable(lazy(() => import("../views/distributors/reports/cashoutReport")));
const AEPSLedgerReport = Loadable(lazy(() => import("../views/distributors/reports/aepsLedgerReport")));
const MoneyTransferReports = Loadable(lazy(() => import("../views/distributors/reports/moneyTransferReports")));
const MoneyTransferHoldReport = Loadable(lazy(() => import("../views/distributors/reports/moneyTransferHoldReport")));
const AEPSTransactionReports = Loadable(lazy(() => import("../views/distributors/reports/aepsTransactionReports")));
const BillPaymentReport = Loadable(lazy(() => import("../views/distributors/reports/billPaymentReport")));
const RailBookingReport = Loadable(lazy(() => import("../views/distributors/reports/railBookingReport")));
const FlightBookingReport = Loadable(lazy(() => import("../views/distributors/reports/flightBookingReport")));
const PaymentGetwayReport = Loadable(lazy(() => import("../views/distributors/reports/paymentGetwayReport")));
const OutStandingReport = Loadable(lazy(() => import("../views/distributors/reports/outStandingReport")));
const TopUpReports = Loadable(lazy(() => import("../views/distributors/reports/topUpReport")));
const PGSettlementReport = Loadable(lazy(() => import("../views/distributors/reports/pgSettlementReport")));
const PGPayoutReconciliationReport = Loadable(lazy(() => import("../views/distributors/reports/pgPayoutReconciliationReport")));


const distributorRouter = {
  path: "user/:userType",
  key: 4,
  element: <ProtectDistributorRoute Component={FullLayout} />,
  children: [
    // Privacy Policy
    {
      key: 4.1,
      path: "privacyPolicy",
      name: "PrivacyPolicy",
      element: <PrivacyPolicy />,
    },
    // Term and Condition
    {
      key: 4.2,
      path: "termsAndCondition",
      name: "termsAndCondition",
      element: <TermsAndCondition />,
    },
    // Dashboard
    {
      key: 4.3,
      path: "dashboard",
      name: "Dashboard",
      element: <DistributorDashboard />,
    },
    // Onboarding KYC
    {
      key: 4.4,
      path: "addDocumentKyc",
      name: "addDocumentKyc",
      element: <AddDocumentKyc />,
    },
    // User Settings
    {
      path: "settings",
      key: 4.5,
      children: [
        // Change My Password
        {
          path: "changesPassword",
          name: "settings-changesPassword",
          element: <ChangesPassword />,
        },
        // User Profile
        {
          path: "profile",
          name: "settings-profile",
          element: <UserProfileHome />,
        },
        // User Profile
        {
          path: "changesTpin",
          name: "settings-changesTpin",
          element: <ChangeTPinWithOld />,
        },
      ]
    },
    // User Self Bank
    {
      key: 4.6,
      path: "selfBank",
      name: "selfBank",
      element: <SelfBank />,
    },
    // Balance Request
    {
      path: "balanceRequest",
      key: 4.7,
      children: [
        // User Balance Request List
        {
          path: "",
          name: "balanceRequest",
          element: <BalanceRequestList />,
        },
        {
          path: "newBalanceRequest",
          name: "newBalanceRequest",
          element: <NewBalanceRequest />,
        },
        // Pending Balance Request
        {
          path: "viewPendingRequest",
          name: "balanceRequest-viewPendingRequest",
          element: <ViewPendingRequestAdmin />,
        },
      ]
    },
    // User Managemnet
    {
      path: "userManagement",
      key: 4.8,
      children: [
        // for all role type user list
        {
          path: ":userType",
          name: "userManagement-allUserTypeList",
          element: <UserManagementList />,
        },
        // for all role type new user
        {
          path: "newUser/:userType",
          name: "userManagement-newUser",
          element: <AddNewUserAdmin />,
        },
        // for all role type user profile
        {
          path: "profile/:userType",
          name: "userManagement-userProfile",
          element: <UpdateUserProfileAdmin />,
        },
        {
          path: "pendingKycVerification",
          name: "userManagement-pendingKycVerification",
          element: <PendingKycVerificationList />,
        },
      ],
    },
    // Services
    {
      path: "services",
      key: 5.9,
      children: [
        // User Balance Request List
        {
          path: "billPayments",
          name: "billPayments[BILL PAYMENTS(PAYSPRINT)]",
          element: <BillPayments />,
        },
        {
          path: "billPayments2",
          name: "billPayments2[BILL PAYMENTS - 2(MULTILINK)]",
          element: <BillPayments />,
        },
        {
          path: "billPayments3",
          name: "billPayments3[BILL PAYMENTS - 3(BILLAVENUE)]",
          element: <BillPayments />,
        },
        {
          path: "offlineBillPay",
          name: "offlineBillPay[OFFLINE BILL PAY(EKO)]",
          element: <OfflineBillPayments />,
        },
        {
          path: "recharge",
          name: "recharge[RECHARGE(AMBIKA)]",
          element: <RechargeBill />,
        },
        {
          path: "recharge2",
          name: "recharge2[RECHARGE - 2(MULTILINK)]",
          element: <RechargeBill />,
        },
        {
          path: "dth",
          name: "dth[DTH(AMBIKA)]",
          element: <RechargeBill />,
        },
        {
          path: "dth2",
          name: "dth2[DTH-2(MULTILINK)]",
          element: <RechargeBill />,
        },
        {
          path: "upiPaymentPayout",
          name: "upiPaymentPayout[UPI PAYMENT PAYOUT(PAY2ALL)]",
          element: <AllPaymentsHome />,
        },
        {
          path: "payout",
          name: "payout([Payoit-1(EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "payout2",
          name: "payout2([Payoit-2(EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "dmt",
          name: "dmt([DMT (EKO)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "dmt2",
          name: "dmt2([DMT-2 (PAYSPRINT)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "ppiDmt",
          name: "ppiDmt([PPI DMT (PAYSPRINT)])",
          element: <AllPaymentsHome />,
        },
        {
          path: "aeps",
          name: "aeps([AEPS (EKO)])",
          element: <AEPSHome />,
        },
        {
          path: "aeps2",
          name: "aeps2([AEPS-2 (CREDOPAY)])",
          element: <AEPSHome />,
        },
        {
          path: "aeps3",
          name: "aeps3([AEPS-3 (PAYSPRINT)])",
          element: <AEPSHome />,
        },
        {
          path: "e-collection",
          name: "e-collection([DYNAMIC QR (EKO)])",
          element: <ECollection />,
        },
      ]
    },
    // Reports
    {
      path: "reports",
      key: 4.11,
      children: [
        {
          path: "ledgerReport",
          name: "reports-ledgerReport",
          element: <LedgerReport />,
        },
        {
          path: "mainWalletLedgerReport",
          name: "reports-mainWalletLedgerReport",
          element: <MainWalletLedgerReport />,
        },
        {
          path: "pgLedgerReport",
          name: "reports-pgLedgerReport",
          element: <PGLedgerReportRetailer />,
        },
        {
          path: "cashoutReport",
          name: "reports-cashoutReport",
          element: <CashoutReport />,
        },
        {
          path: "aepsLedgerReport",
          name: "reports-aepsLedgerReport",
          element: <AEPSLedgerReport />,
        },
        {
          path: "moneyTransferReports",
          name: "reports-moneyTransferReports",
          element: <MoneyTransferReports />,
        },
        {
          path: "moneyTransferHoldReports",
          name: "reports-moneyTransferHoldReports",
          element: <MoneyTransferHoldReport />,
        },
        {
          path: "aepsTransactionReports",
          name: "reports-aepsTransactionReports",
          element: <AEPSTransactionReports />,
        },
        {
          path: "billPaymentReports",
          name: "reports-billPaymentReports",
          element: <BillPaymentReport />,
        },
        {
          path: "railBookingReports",
          name: "reports-railBookingReports",
          element: <RailBookingReport />,
        },
        {
          path: "flightBookingReports",
          name: "reports-flightBookingReports",
          element: <FlightBookingReport />,
        },
        {
          path: "paymentGetwayReports",
          name: "reports-paymentGetwayReports",
          element: <PaymentGetwayReport />,
        },
        {
          path: "outStandingReports",
          name: "reports-outStandingReports",
          element: <OutStandingReport />,
        },
        {
          path: "topUpReports",
          name: "reports-topUpReports",
          element: <TopUpReports />,
        },
        {
          path: "pgSettlementReports",
          name: "reports-pgSettlementReports",
          element: <PGSettlementReport />,
        },
        {
          path: "pgPayoutReconciliationReports",
          name: "reports-pgPayoutReconciliationReports",
          element: <PGPayoutReconciliationReport />,
        },
      ]
    },
    // User Manage Credit/Debit
    {
      key: 4.12,
      path: "manageCreditDebit",
      name: "manageCreditDebit",
      element: <ManageCreditDebit />,
    },
    // User Credit Details
    {
      key: 4.13,
      path: "creditDetails",
      name: "creditDetails",
      element: <CreditDetails />,
    },
    // User Wallet to Wallet Transfer
    {
      key: 4.14,
      path: "walletToWalletTransferReports",
      name: "WalletToWalletTransferReports",
      element: <WalletToWalletTransferReports />,
    },
    {
      key: 4.14,
      path: "walletToWalletTransfer",
      name: "WalletToWalletTransfer",
      element: <WalletToWalletTransfer />,
    },
  ],
};

export default distributorRouter;
